<script setup lang="ts">
defineProps({
  to: {
    type: String,
    required: false,
    default: null,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  external: {
    type: Boolean,
    required: false,
    default: false,
  },
  target: {
    type: String as PropType<'_self' | '_blank' | '_top' | '_parent'>,
    required: false,
    default: '_self',
  },
});
</script>
<template>
  <ULink :to="to" active active-class="text-primary-500" class="me-1 cursor-pointer" :disabled="disabled" :target="target" :external="external"
    ><UIcon name="ic:outline-keyboard-double-arrow-right" class="align-middle" /><slot
  /></ULink>
</template>
